import { useState } from 'react';

import { useAppContext } from '../../../store/App/utils/useAppContext';
import { useTranscriptContext } from '../../../store/transcript/utils/useTranscriptContext';

export const useResetChat = () => {
  const {
    endpoints: { resetChat },
  } = useAppContext();
  const { state, resetSession } = useTranscriptContext();
  const [error, setError] = useState<string | null>(null);

  const resetChatSession = () => {
    const sessionId = state.sessionId;
    let error = null;

    if (sessionId) {
      if (resetChat) {
        resetChat(sessionId).then((isReset) => {
          if (isReset) {
            error = null;
            resetSession?.();
          } else {
            error = 'Failed to reset chat';
          }
        });
      } else {
        error = null;
        resetSession?.();
      }
    } else {
      error = 'Session Id not found';
    }

    setError(error);

    setTimeout(() => {
      setError(null);
    }, 2000);
  };

  return { resetChatSession, error };
};
